export enum RetirementAccountCustomFieldKey {
	NameOfInstitution = 'retirementAccountNameOfInstitution',
	RetirementAccountType = 'retirementAccountType',
}